module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/icon-all@3x-5cdb40da32e8582fce723f5f90a9c426.png";